// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"anticlockwise"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M8.99902 7H21.999V20H8.99902V7Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M8.99902 7H21.999V20H8.99902V7Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M12.0003 3H7.3333C6.22887 3 5.33349 3.89522 5.3333 4.99965L5.33235 10.5H4.7768L1.99902 7.5","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-anticlockwise')
export default class AnticlockwiseIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'anticlockwise',
    }
  }
}
